// extracted by mini-css-extract-plugin
export default {"formVerify":"AccountVerify_formVerify__rJCu5","FormInputVerify":"AccountVerify_FormInputVerify__qC5vN","verifyBtn":"AccountVerify_verifyBtn__9fMJA"};